<template>
    <span :class="['status-icon', icon]"></span>
</template>
<script>
    export default {
        name: 'statusIcon',
        props: {
            icon: String
        }
    }
</script>
<style lang="scss" scoped>
    .status-icon {
        width          : 48px;
        height         : 21px;
        display        : inline-block;
        vertical-align : middle;
        background     : url('~images/icons/status-tips.png') no-repeat 0 0;
        &.undetermined {
            background-position : 0 -31px;
        }
        &.lh {
            background-position : 0 -62px;
        }
        &.not-deal {
            background-position : 0 -93px;
        }
        &.fq {
            background-position : 0 -125px;
        }
    }
</style>


// WEBPACK FOOTER //
// statusIcon.vue?021719c3